import React, { useState } from "react";
import { useLanguage } from "../LanguageContext";
import { languages } from "../i18n";

export default function LanguageSelector() {
  const { lang, setLang } = useLanguage();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1 text-sm bg-white border border-gray-200 rounded-full px-3 py-1.5 font-semibold"
      >
        <span>{languages[lang as keyof typeof languages]?.flag}</span>
        <span className="text-xs">{languages[lang as keyof typeof languages]?.name}</span>
        <span className="text-gray-400 text-xs">▾</span>
      </button>

      {open && (
        <div className="absolute right-0 top-10 bg-white rounded-2xl shadow-lg border border-gray-100 z-50 overflow-hidden min-w-36">
          {Object.entries(languages).map(([code, info]) => (
            <button
              key={code}
              onClick={() => { setLang(code); setOpen(false); }}
              className={"w-full flex items-center gap-2 px-4 py-3 text-sm hover:bg-gray-50 " +
                (lang === code ? "bg-blue-pale text-mouna-blue font-bold" : "text-navy")}
            >
              <span>{info.flag}</span>
              <span>{info.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
